import {
  AvailabilityPeriod,
  CreateAvailabilityPeriod,
  UpdateAvailabilityPeriod,
} from '@/integrations/mysql/types';
import { apiJson, apiJsonArray } from '@/lib/api-client';

export class AvailabilityService {
  static async getAvailabilityPeriods(
    propertyId: number,
  ): Promise<AvailabilityPeriod[]> {
    return apiJsonArray<AvailabilityPeriod>(
      `api/availability/property/${propertyId}/periods`,
    );
  }

  static async getAvailabilityPeriodsForUser(
    propertyId: number,
    _userId: number,
  ): Promise<AvailabilityPeriod[]> {
    return this.getAvailabilityPeriods(propertyId);
  }

  static async getUserPendingPeriods(
    propertyId: number,
    userId: number,
  ): Promise<AvailabilityPeriod[]> {
    return apiJsonArray<AvailabilityPeriod>(
      `api/availability/property/${propertyId}/pending/${userId}`,
    );
  }

  static async getAvailabilityPeriodById(
    periodId: number,
  ): Promise<AvailabilityPeriod | null> {
    return apiJson<AvailabilityPeriod | null>(
      `api/availability/periods/by-id/${periodId}`,
    );
  }

  static async createAvailabilityPeriod(
    periodData: CreateAvailabilityPeriod,
  ): Promise<AvailabilityPeriod> {
    return apiJson<AvailabilityPeriod>('api/availability/periods', {
      method: 'POST',
      body: JSON.stringify(periodData),
    });
  }

  static async updateAvailabilityPeriod(
    periodId: number,
    updateData: UpdateAvailabilityPeriod,
  ): Promise<AvailabilityPeriod | null> {
    return apiJson<AvailabilityPeriod | null>(
      `api/availability/periods/${periodId}`,
      {
        method: 'PUT',
        body: JSON.stringify(updateData),
      },
    );
  }

  static async deleteAvailabilityPeriod(periodId: number): Promise<boolean> {
    await apiJson(`api/availability/periods/${periodId}`, {
      method: 'DELETE',
    });
    return true;
  }

  static async isPeriodAvailable(periodId: number): Promise<boolean> {
    const r = await apiJson<{ value: boolean }>(
      `api/availability/period/${periodId}/available`,
    );
    return r.value;
  }

  static async getAvailablePeriodsInRange(
    propertyId: number,
    startDate: Date,
    endDate: Date,
  ): Promise<AvailabilityPeriod[]> {
    const s = startDate.toISOString().slice(0, 10);
    const e = endDate.toISOString().slice(0, 10);
    return apiJsonArray<AvailabilityPeriod>(
      `api/availability/property/${propertyId}/range?start=${s}&end=${e}`,
    );
  }

  static async getAvailabilityPeriodsByOwner(
    ownerId: number,
  ): Promise<AvailabilityPeriod[]> {
    return apiJsonArray<AvailabilityPeriod>(
      `api/availability/owner/${ownerId}/periods`,
    );
  }
}
